module.exports = __webpack_public_path__ + "static/media/clippy0.8e00acab.png";